<template>
  <div id="confirmation">
    <page-heading>RSVP Confirmation</page-heading>
    <div id="content">
      <div
        id="attendance-confirmation"
        v-if="user.attendance != 'Neither'">
        <h3>Thank you for RSVPing for the Open House on</h3>
        <h2>{{ eventDate }}</h2>
        <h3 style="margin-top: -1rem">{{ eventTime }}</h3>
        <div style="text-align:center">
          <a
            class="btn"
            style="font-size: .9rem; padding: .5rem 1.5rem;"
            v-if="eventURL"
            :href="eventURL"
            target="_blank"
            rel="nofollow">Add to Google Calendar</a>
        </div>
      </div>
      <div
        id="attendance-confirmation"
        v-else>
        <h3>We will contact you to schedule a visit.</h3>
      </div>
      <div
        id="school-info-boys"
        class="info-block"
        v-if="boysSchool">
        <h3>About the School for Boys</h3>
        <div class="embed-container">
          <iframe
            src="https://www.youtube.com/embed/Bi37-z5m5Qo?rel=0&showinfo=0"
            frameborder="0"
            allowfullscreen/>
        </div>
      </div>
      <div
        id="school-info-girls"
        class="info-block"
        v-if="girlsSchool">
        <h3>About the School for Girls</h3>
        <div class="embed-container">
          <iframe
            src="https://www.youtube.com/embed/0zZFvau3SC8?rel=0&showinfo=0"
            frameborder="0"
            allowfullscreen/>
        </div>
      </div>
      <div
        id="what-to-expect"
        class="info-block"
        v-if="user.attendance != 'Neither'">
        <h3>What to Expect</h3>
        <ul>
          <li>Opening presentation from the academic administration</li>
          <li>Student-led tours</li>
          <li>Meet-and-greet with coaches</li>
          <li>Clubs and activities fair</li>
          <li>Financial aid information</li>
          <li>Refreshments</li>
        </ul>
        <div style="text-align:center">
          <router-link
            to="/faq"
            class="btn btn--yellow">FAQ</router-link>
        </div>
      </div>
      <div
        id="directions"
        class="info-block">
        <h3>Location</h3>
        <p>Malden Catholic is located at 99 Crystal Street, Malden, Massachusetts 02148</p>
        <div class="button-container">
          <a
            href="https://www.maldencatholic.org/about-us/directions-to-mc"
            target="_blank"
            class="btn">Get Directions</a>
          <a
            href="https://goo.gl/maps/FZ3MQw3te1x"
            target="_blank"
            class="btn">Google Maps</a>
        </div>
      </div>
      <div
        id="contact-us"
        class="info-block"
        style="text-align:center">
        <p>Phone: <a href="tel:17814755293">(781) 475-5293</a><span class="mobile"><br></span><span class="non-mobile">&emsp;&bull;&emsp;</span>Web: <a href="https://www.maldencatholic.org">maldencatholic.org</a></p>
      </div>
    </div><!--/#content-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Confirmation',
  data() {
    return {
      boysSchool: false,
      girlsSchool: false,
      eventURL: undefined,
    };
  },
  mounted() {
    this.submitUserToConstantContact();
    this.checkSchools();
    this.setEventURL();
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    eventDate() {
      if (this.user.attendance === 'October 25') {
        return 'Oct. 25';
      } else if (this.user.attendance === 'November 3') {
        return 'Nov. 3';
      }
    },
    eventTime() {
      if (this.user.attendance === 'October 25') {
        return '6:30pm';
      } else if (this.user.attendance === 'November 3') {
        return '1pm';
      }
    },
  },
  methods: {
    checkSchools() {
      this.user.children.forEach((child) => {
        if (child.enteringSchool === 'Boys') {
          this.boysSchool = true;
        }
        if (child.enteringSchool === 'Girls') {
          this.girlsSchool = true;
        }
      });
    },
    setEventURL() {
      let dateString = '';
      if (this.user.attendance === 'October 25') {
        dateString = '20181025T223000Z/20181025T253000Z';
      } else if (this.user.attendance === 'November 3') {
        dateString = '20181103T170000Z/20181103T200000Z';
      }
      if (dateString !== '') {
        this.eventURL = `http://www.google.com/calendar/event?action=TEMPLATE&text=Malden Catholic Open House&dates=${dateString}&ctz=America/New_York&details=Open House at Malden Catholic&location=Malden Catholic High School, 99 Crystal St, Malden, MA 02148, USA&trp=false&sprop=&sprop=name:`;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../scss/variables';

#confirmation {
  .mobile {
    display: initial;
  }

  .non-mobile {
    display: none;
  }

  color: white;
  h3 {
    text-align: center;
    font-size: 1.25rem;
  }
  h2 {
    text-align: center;
    font-size: 2rem;
  }

  #attendance-confirmation,
  .info-block {
    margin-bottom: 3rem;
  }

  #attendance-confirmation {
    h3 {
      margin-bottom: 1rem;
    }
    h2 {
      margin-bottom: 1rem;
    }
  }
  .embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe, object, embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .info-block {
    h3 {
      padding-bottom: 1em;
      margin-bottom: 1em;
      border-bottom: 1px solid;
    }
    p, ul {
      font-size: 1.25rem;
      line-height: 1.4;
      margin-bottom: 1rem;

      a {
        font-weight: bold;
        color: $secondary-color;
        transition: all .15s ease;
        &:hover {
          background: $secondary-color;
          color: $primary-color;
        }
      }
    }

    ul {
      margin-left: 3rem;
    }
  }

  .button-container {
    text-align: center;
    .btn {
      width: 100%;
      display: block;
    }

    .btn + .btn {
      margin-top: 1rem;
    }
  }
}

@media (min-width: 480px){
  #confirmation {
    .mobile {
      display: none;
    }

    .non-mobile {
      display: initial;
    }

    .button-container {
      .btn {
        width: auto;
        display: inline-block;
      }

      .btn + .btn {
        margin-top: 0;
        margin-left: 1rem;
      }
    }
  }
}
</style>

